module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/23-494624f391e3cba9ed54c7c04aadd14b.jpg";